import React, { useState, createContext, useEffect } from "react";
import * as api from "service/api";

const StoreContext = createContext();

const StoreProvider = ({ children }) => {
  const [store, setStore] = useState({});

  useEffect(() => {
    const fn = async () => {
      const token = localStorage.getItem("token");
      if (token) {
        const result = await api.getMe();
        if (result.success) {
          setStore(store => ({
            ...store,
            user: result.data,
            isAdmin: result.data.isAdmin || false,
          }));
        } else {
          localStorage.setItem("token", "");
          api.setAuthToken(false);
          setStore(store => ({ ...store, user: null, isAdmin: false }));
        }
      } else {
        setStore(store => ({ ...store, isAdmin: false }));
      }
    };

    fn();
  }, []);

  return (
    <StoreContext.Provider
      value={{
        store,
        setStore,
      }}
    >
      {children}
    </StoreContext.Provider>
  );
};

export { StoreContext, StoreProvider };
